






































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Action } from 'vuex-class'
// import { Prop } from 'vue-property-decorator'


// import DigitalCurrency5AccountThumbnail from '../../digital-currency-account/account-thumbnail/index.vue'
// import DigitalCurrency7ccountBalanceNumberWithIcon from '../../digital-currency-account/account-balance-number-with-icon/index.vue'
// import Input1TextInputForSearch from '../../../../website/data-structures/text-input-for-search/index.vue'

import { getValueFromQrCode } from './service-for-helper-algorithms/helper-algorithms-7-get-value-from-qr-code'

import { isValidHttpUrl } from '../basic-type-4-user-interface/service-for-algorithms/algorithms-1-is-valid-http-url'

const namespace = 'digitalCurrency'

@Component({
  components: {
    // DigitalCurrency5AccountThumbnail,
    // DigitalCurrency7ccountBalanceNumberWithIcon,
    // Input1TextInputForSearch
  }
})
class DigitalCurrency12QrCodeScannerPresentation extends Vue {

  @Action('getDigitalCurrencyAccountById', { namespace }) getDigitalCurrencyAccountById?: any

  qrCodeResultTable: { [qrCodeResult: string]: {
    digitalCurrencyAccount?: any
    productResource?: any
    textValue?: string
    isValidUrl?: boolean
    orderIndex: number
  }} = {}

  stopVideoFeedFromCamera: boolean = false
  isVideoAddedToContainerElement: boolean = false

  mounted () {
    this.stopVideoFeedFromCamera = false
    this.getQRCodeValueFromCamera()
  }

  destroyed () {
    this.stopVideoFeedFromCamera = true
  }

  // Emit Toggle show content
  emitToggleShowContent ({ isVisible }: { isVisible: boolean }) {
    this.$emit('toggleShowContent', { isVisible })
  }

  getQRCodeValueFromCamera () {
    const self = this
    const videoContainerElement = this.$refs['videoContainerElement'] as HTMLElement

    getValueFromQrCode(200, 200, (videoResult, qrCodeTemporaryResult) => {

      self.addQrCodeResult(qrCodeTemporaryResult).catch((_errorMessage) => { /* */ })

      if (!self.isVideoAddedToContainerElement) {
        videoContainerElement.appendChild(videoResult)
        self.isVideoAddedToContainerElement = true
      }
    }, () => {
      return self.stopVideoFeedFromCamera
    }).catch((errorMessage: any) => {
      console.log(errorMessage)
    })
  }

  get qrCodeResultList () {
    let qrCodeResultList = []
    for (let qrCodeResultValue in this.qrCodeResultTable) {
      if (!this.qrCodeResultTable.hasOwnProperty(qrCodeResultValue)) {
        continue
      }

      qrCodeResultList.push(this.qrCodeResultTable[qrCodeResultValue])
    }

    qrCodeResultList.sort((a, b) => {
      return a.orderIndex - b.orderIndex
    }).reverse()

    return qrCodeResultList
  }

  async addQrCodeResult (resultValue: string) {
    if (!resultValue) {
      return
    }

    const qrCodeResultRecord = this.qrCodeResultTable[resultValue]

    if (qrCodeResultRecord) {
      return
    }

    let digitalCurrencyAccount = this.getIsValidId(resultValue) ? await this.getDigitalCurrencyAccountById(resultValue) : null
    let productResource = null

    Vue.set(this.qrCodeResultTable, resultValue, {
      digitalCurrencyAccount,
      productResource,
      textValue: resultValue,
      isValidUrl: isValidHttpUrl(resultValue),
      orderIndex: Object.keys(this.qrCodeResultTable).length
    })
  }

  getIsValidId (stringValue: string) {
    let regularExpression = /^[A-Za-z0-9]+$/
    return stringValue.match(regularExpression)
  }

  openAccount (digitalCurrencyAccount: any) {
    this.$router.push({ name: 'Account', params: {
      accountUsername: digitalCurrencyAccount.accountUsername
    }}).catch((_errorMessage: any) => { /* */ })
    this.emitToggleShowContent({ isVisible: false })
  }

  openUrl (urlValue: string) {
    window.open(urlValue, '_blank')!.focus()
  }
}

export default DigitalCurrency12QrCodeScannerPresentation


